export const jobTypesSelector = (state) => state.jobTypes.jobTypes;
export const jobTypeSelector = (state) => state.jobTypes.jobTypes;
export const loadingJobTypeSelector = (state) => state.jobTypes.loading;
